// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2IPxH","container--v2":"styles_container--v2__QdgZx","skeleton-animation":"styles_skeleton-animation__EV8z9"};